import { v4 as uuidv4 } from "uuid";

import TAwsConfig from "../../../../awsConfig";

// create new transaction id with optional transaction id
export const getCovid = (transactionId = null) => {
  return `${transactionId || uuidv4()}:0:${TAwsConfig.product.PRODUCT_KEY}-app`;
};
